let AbstractLogicalGeometryOperationResult = require('./abstractLogicalOperationResult');

/**
 * Класс IsWithinResult определяет структуру результата логической проверки на включение одного объекта в другой
 * @extends AbstractLogicalGeometryOperationResult
 */
class IsWithinResult extends AbstractLogicalGeometryOperationResult {
  /**
   * Создает экземпляр класса IsWithinResult
   * @param params
   */
  constructor(params) {
    super(params);
    this.type = "IsWithinResult";
  }
}

module.exports = IsWithinResult;